import { render, staticRenderFns } from "./ym-cost.vue?vue&type=template&id=4694e017&scoped=true&"
import script from "./ym-cost.vue?vue&type=script&lang=js&"
export * from "./ym-cost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4694e017",
  null
  
)

export default component.exports